module.exports = __webpack_public_path__ + "media/images/prevention_form/gluecksspiele-d5109856216aeaca7aef82089b881fa9.svg";